<template>
  <img
    class=""
    alt="logo"
    :src="logoPathForClient"
    :width="width"
    :height="height"
  />
</template>

<script>
import { getClientName } from "@/utils/client";

export default {
  data() {
    return {
      clientName: getClientName(),
    };
  },
  props: {
    width: Number,
    height: Number,
  },
  computed: {
    logoPathForClient() {
      return require(`@/assets/logos/${this.clientName}/logo.svg`);
    },
  },
};
</script>

